module.exports = __webpack_public_path__ + "static/assets/679ce05ac8c35bbf83f596e895ab711b.svg";